<template>
  <div>
    <v-dialog v-model="ModalAdd" persistent max-width="50%">
      <v-card>
        <v-card-title> Tambah Data </v-card-title>

        <v-divider class="mt-2 mb-5"></v-divider>

        <v-card-text>
          <v-form ref="form">
            <v-row dense>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="ikhtisar_ket"
                  label="Ikhtisar Jabatan"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mt-n5"></v-divider>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="gray" @click="closeModal()"> Batal </v-btn>

          <v-btn color="primary" @click="add()" v-if="LBtn"> Simpan </v-btn>
          <v-btn color="primary" loading v-else> Simpan </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

import SAdd from "@/store/anjab/infojabatan/ikhtisarjab/add";
import SView from "@/store/anjab/infojabatan/ikhtisarjab/view";

export default {
  computed: {
    ModalAdd: {
      get() {
        return SAdd.state.ModalAdd;
      },
      set(value) {
        SAdd.commit("TModal", value);
      },
    },

    SData: {
      get() {
        return SAdd.state.data;
      },

      set(value) {
        console.log(value);
      },
    },
  },

  watch: {
    async ModalAdd() {},
  },

  data: () => ({
    token: Cookie.get("token"),
    LBtn: true,

    ikhtisar_ket: null,
  }),

  methods: {
    reset() {
      this.$refs.form.reset();
    },

    async add() {
      this.LBtn = false;

      let data = {
        jab_id: this.$route.params.id,
        ikhtisar_ket: this.ikhtisar_ket,
      };
      
      const url = `${process.env.VUE_APP_API}/ikhtisar/add`;

      this.axios
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.LBtn = true;
          if (res.data.success) {
            SView.commit("refreshData", true);
            SView.commit("alert", res.data.message);
            SView.commit("berhasilAlert", true);
            SView.commit("gagalAlert", false);
            SView.commit("success", res.data.success);
          } else {
            SView.commit("refreshData", true);
            SView.commit("alert", res.data.message);
            SView.commit("gagalAlert", true);
            SView.commit("berhasilAlert", false);
            SView.commit("success", res.data.success);
          }

          this.closeModal();
        })
        .catch((error) => {
          SView.commit("refreshData", true);
          SView.commit("alert", error.response.data.message);
          SView.commit("gagalAlert", true);
          SView.commit("berhasilAlert", false);
          SView.commit("success", error.response.data.success);
          console.log(error.response.status);
          console.log("Error", error.message);
          this.LBtn = true;

          this.closeModal();
        });
    },

    async closeModal() {
      await SView.commit("refreshData", true);
      this.reset();
      this.ModalAdd = false;
    },
  },
};
</script>
